import { useMutation, useSuspenseQuery } from "@tanstack/react-query";
import {
	BBBackendClient,
	BBBackendQueryKeys,
	BBBackendQueryOptions,
} from "@bidbattles/bloks/lib/rapace";
import { toast } from "sonner";
import { m } from "@/paraglide/messages";

export function useUnreadNotificationStatus() {
	const { data } = useSuspenseQuery(
		BBBackendQueryOptions.listNotifications({ status: "unread" }),
	);
	return data.notifications.length !== 0;
}

export function useNotifications(params: { status?: "unread" } = {}) {
	const {
		data: { notifications, pagination },
	} = useSuspenseQuery(BBBackendQueryOptions.listNotifications(params));

	const markAsReadMutation = useMutation({
		mutationKey: [BBBackendQueryKeys.notifications],
		mutationFn: async (id: string) => {
			const result = await BBBackendClient.markNotificationAsRead({ id });
			if (!result.ok) {
				toast.error(m.error_toast({ message: result.error.message }));
				return;
			}
		},
	});

	return {
		notifications,
		pagination,
		markAsRead: markAsReadMutation.mutateAsync,
		isMarkingAsRead: markAsReadMutation.isPending,
	};
}
